/**
 * 'Rpc' has been upgraded to an Nx Lib and should be imported from:
 *
 * ```typescript
 * import { Rpc } from '@mode/shared/util-iframe';
 * ```
 *
 * 'Emit' still has dependencies on legacy EmitTransport and Messages
 * that cannot be moved as part of this migration
 */
import { InjectionToken } from '@angular/core';

// The sandbox types library has a lot of boundary issues that are bubbling up here.
// If we resolve those, we can remove this.
// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitTransport } from '@mode/reports/sandbox/contract';
import { Rpc } from '@mode/shared/util-iframe';
import { Emit } from './emit-transport';

export { Rpc, Emit };

export const EmitTransportToken = new InjectionToken<EmitTransport>('EmitTransport', {
  providedIn: 'root',
  factory: () => Emit,
});
